/**
 * Normalizes column IDs to ensure consistency across the application.
 * Specifically handles the "Created by" column which is stored as "createdBy".
 * 
 * @param id - The column ID to normalize
 * @returns The normalized column ID
 */
export const normalizeColumnId = (id: string | undefined): string => {
  if (!id) return '';
  return id === "Created by" ? "createdBy" : id;
};
